import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
// import { Radio, FormControlLabel } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import Papa from 'papaparse';

const NearbyPlacesComponent = ({ lat, lng, mapData }) => {
  const [nearbyPlaces, setNearbyPlaces] = useState({ neighborhood: "", restaurants: [], hospitals: [], placeOfWorships: [], socialFacility: [], schools: [], daycare: [], university: [], parks: [], library: [], buses: [], alcohol: [], bars: [], gasStations: [], publicBuilding: [] });
  const [showIcons, setShowIcons] = useState({ restaurants: false, hospitals: false, placeOfWorships: false, socialFacility: false, schools: false, daycare: false, university: false, parks: false, library: false, buses: false, alcohol: false, bars: false, gasStations: false, publicBuilding: false });
  const [showLayer, setShowLayer] = useState({ restaurants: false, hospitals: false, placeOfWorships: false, socialFacility: false, schools: false, daycare: false, university: false, parks: false, library: false, buses: false, alcohol: false, bars: false, gasStations: false, publicBuilding: false });
  const [additionalData, setAdditionalData] = useState(null);
  // const [selectedAttribute, setSelectedAttribute] = useState({ name: '', value: '' });


  // // Define the specific features (keys) you want to display 
  // const selectedFeatures = ["NBHNAME", "Property", "Violent", "VC_1000_Rate", "PC_1000_Rate", ];

  const additionalInfoDisplayNames = {
    nbhname: "Neighborhood Name",
    violent: "Violent Crime Count",
    property: "Property Crime Count",
    vc_1000_rate: "Violent Crime Rate (per 1000)",
    pc_1000_rate: "Property Crime Rate (per 1000)",
    total_pop: "Total Population",
    pct_hispanic: "Density of Race and Hispanic Origin",
    pct_nonwhite: "% of Population that is Non-White and/or Hispanic",
    pct_pop_below_pov: "% Population Below Poverty",
    pct_hhs_public_assist: "% of families in public assistance",
    median_income: "Median Income",
    pct_unemployed: "% Unemployed",
    pct_hhs_public_assist_withchildren: "% Children in Households Receiving Public Assistance",
    pct_single_hh_withchildren: "% Single Parent Households",
    pct_uninsured: "% of Population that is Uninsured",
    life_expectancy_at_birth_2010_2015: "Life Expectancy- Difference from Regional Average",
  };  


  const groupedAdditionalInfo = {
    Crime: {
      displayName: "Crime",
      attributes: ["violent", "property", "vc_1000_rate", "pc_1000_rate"],
    },
    Demographics: {
      displayName: "Demographic",
      attributes: ["total_pop", "pct_hispanic", "pct_nonwhite"],
    },
    Economics: {
      displayName: "Economics",
      attributes: ["pct_pop_below_pov", "pct_hhs_public_assist", "median_income", "pct_unemployed", "pct_hhs_public_assist_withchildren", "pct_single_hh_withchildren"],
    },
    Health: {
      displayName: "Health",
      attributes: ["pct_uninsured", "life_expectancy_at_birth_2010_2015"],
    },
  };


  const groupedCategories = {
    "Transportation": ["buses"],
    "Education": ["schools", "daycare", "university"],
    "Food and Dining": ["restaurants", "bars"],
    "Recreation and Leisure": ["parks", "library"],
    "Healthcare": ["hospitals"],
    "Stores": ["gasStations", "alcohol"],
    "Community and Social Services": ["socialFacility", "placeOfWorships"],
    "Government and Public Services": ["publicBuilding"]
  };


  const displayNames = {
    restaurants: "Restaurants and Fast Food",
    hospitals: "Hospitals",
    schools: "Schools",
    daycare: "Daycares",
    university: "Colleges/Universities",
    parks: "Parks",
    library: "Libraries",
    bars: "Bars and Nightlife",
    buses: "Bus Stops",
    gasStations: "Gas Stations",
    alcohol: "Liquor Stores",
    placeOfWorships: "Places of Worship",
    socialFacility: "Social Facilities and Centers",
    publicBuilding: "Government Buildings"
  };
  


  const handleCheckboxChange = (category, isChecked) => {
    setShowIcons(prev => ({ ...prev, [category]: isChecked }));
    mapData({ ...nearbyPlaces, showIcons: { ...showIcons, [category]: isChecked }, showLayer });
  };

  const handleLayerCheckboxChange = (category, isChecked) => {
    setShowLayer(prev => ({ ...prev, [category]: isChecked }));
    mapData({ ...nearbyPlaces, showIcons, showLayer: { ...showLayer, [category]: isChecked } });
  };

  // const handleAttributeSelect = (attribute) => {
  //   if (additionalData && additionalData.length > 0) {
  //     const attributeValue = additionalData[0][attribute];
  //     setSelectedAttribute({ name: attribute, value: attributeValue });
  //     mapData({ 
  //       ...nearbyPlaces, 
  //       showIcons, 
  //       showLayer, 
  //       selectedAttribute: { name: attribute, value: attributeValue },
  //     });
  //   }
  // };

  const getCategoryTableRows = (categories) => (
    categories.map(category => (
      <TableRow key={category}>
        <TableCell>{displayNames[category]}</TableCell> {/* Use the display name */}
        <TableCell>{nearbyPlaces[category]?.length || 0}</TableCell>
        <TableCell>
          <Checkbox
            checked={!!showIcons[category]}
            onChange={(e) => handleCheckboxChange(category, e.target.checked)}
          />
        </TableCell>
        <TableCell>
          <Checkbox
            checked={!!showLayer[category]}
            onChange={(e) => handleLayerCheckboxChange(category, e.target.checked)}
          />
        </TableCell>
      </TableRow>
    ))
  );


  // // Fetch additional data based on the neighborhood
  // const fetchAdditionalData = (neighborhoodID) => {
  //   Papa.parse('/merged_output.csv', {
  //     download: true,
  //     header: true,
  //     skipEmptyLines: true,
  //     dynamicTyping: true,
  //     complete: (results) => {
  //       const data = results.data.filter(row => row.NBHID?.toString().trim() === neighborhoodID.trim());
  //       setAdditionalData(data);
  //     },
  //     error: (error) => console.error('Error loading CSV:', error),
  //   });
  // };

  const fetchCrimeData = async (nhdid) => {
    try {
      const host = process.env.REACT_APP_API_HOST || 'localhost';
      const port = process.env.REACT_APP_API_PORT || '8888';
      const protocol = process.env.REACT_APP_API_PROTOCOL || 'http';

      const response = await fetch(`${protocol}://${host}:${port}/map/get_neighborhood/${nhdid}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      console.log(data)
      setAdditionalData(data.__data__);
    } catch (error) {
      console.error('There was a problem with fetching crime data:', error);
    }
  };

  
  useEffect(() => {
    const neighborhoodsGeoJSON = require('assets/map/KC-neighborhood-outline.json');
    const filterPlacesByNeighborhood = (places, neighborhoodsCoordinates) => {
      const filteredPlaces = [];

      places.forEach(place => {
        if (isPointInPolygon(place, neighborhoodsCoordinates)) {
          filteredPlaces.push({
            ...place
          });
        }
      });

      return filteredPlaces;
    };

    const findNeighborhoodByCoordinates = (clickedCoords, neighborhoodsGeoJSON) => {
      let neighborhoodFound = null;

      neighborhoodsGeoJSON.features.some(neighborhood => {
        if (isPointInPolygon(clickedCoords, neighborhood.geometry.coordinates[0][0])) {
          neighborhoodFound = {
            properties: neighborhood.properties,
            geometry: neighborhood.geometry
          };
          return neighborhoodFound;
        }
        return neighborhoodFound;
      });

      if (neighborhoodFound !== null) {
        const neighborhoodCenter = findNeighborhoodCenter(neighborhoodFound.geometry.coordinates[0][0]);
        const maxDistance = findMaxDistanceFromCenter(neighborhoodCenter, neighborhoodFound.geometry.coordinates[0][0]);
        return {
          ...neighborhoodFound,
          center: neighborhoodCenter,
          maxDistance: maxDistance,
        };
      }

      return neighborhoodFound;
    };

    const findNeighborhoodCenter = (neighborhoodPolygon) => {
      let x = 0, y = 0, n = neighborhoodPolygon.length;
      neighborhoodPolygon.forEach(point => {
        x += point[0];
        y += point[1];
      });
      return { longitude: x / n, latitude: y / n }; // Centroid of the polygon
    };

    const findMaxDistanceFromCenter = (center, neighborhoodPolygon) => {
      const centerPoint = L.latLng(center.latitude, center.longitude);
      let maxDistance = 0;
      neighborhoodPolygon.forEach(point => {
        const distance = centerPoint.distanceTo(L.latLng(point[1], point[0]));
        if (distance > maxDistance) {
          maxDistance = distance;
        }
      });
      return maxDistance;
    };

    const isPointInPolygon = (point, polygon) => {
      const x = point.longitude;
      const y = point.latitude;

      let inside = false;
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i][0];
        const yi = polygon[i][1];
        const xj = polygon[j][0];
        const yj = polygon[j][1];

        const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }

      return inside;
    };

    const calculateCentroid = geometry => {
      let sumLat = 0;
      let sumLon = 0;

      // Iterate over each coordinate in the polygon
      for (const coord of geometry) {
        sumLat += coord.lat;
        sumLon += coord.lon;
      }

      // Calculate the average latitude and longitude
      const centroidLat = sumLat / geometry.length;
      const centroidLon = sumLon / geometry.length;

      return { lat: centroidLat, lon: centroidLon };
    };

    const normalizeData = (resp) => {
      return resp.data.elements.map(element => {
        if (element.type === 'node') {
          return {
            name: element.tags.name,
            latitude: element.lat,
            longitude: element.lon,
            data: element
          };
        } else if (element.type === 'way') {
          const centroid = calculateCentroid(element.geometry);
          return {
            name: element.tags.name,
            latitude: centroid.lat,
            longitude: centroid.lon,
            data: element
          };
        } else if (element.type === 'relation') {
          // Fixme - This has way types nested in it
          const lat = (element.bounds.maxlat + element.bounds.minlat) / 2;
          const lon = (element.bounds.maxlon + element.bounds.minlon) / 2;
          return {
            name: element.tags.name,
            latitude: lat,
            longitude: lon,
            data: element
          };
        }
      });
    };

    const getNearbyPlacesInNeighborhoods = async () => {
      try {
        console.log("Got lat lng:", lat, lng)
        let neighborhoodFound = findNeighborhoodByCoordinates({longitude: lng, latitude: lat},neighborhoodsGeoJSON)
        console.log("Found n:", neighborhoodFound)
        fetchCrimeData(neighborhoodFound.properties.nbhid);
        // fetchAdditionalData(neighborhoodFound.properties.nbhid); // Fetch additional data based on neighborhood ID      neighborhoodFound.properties.nbhname

        console.log("test:", additionalData)

        const placeOfWorshipsQuery = `[out:json];(
          node["amenity"="place_of_worship"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="place_of_worship"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="place_of_worship"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const socialFacilityQuery = `[out:json];(
          node["amenity"="social_facility"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          node["amenity"="social_centre"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="social_facility"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="social_centre"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          rel["amenity"="social_facility"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          rel["amenity"="social_centre"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const schoolsQuery = `[out:json];(
          node["amenity"="school"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="school"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          rel["amenity"="school"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const daycareQuery = `[out:json];(
          node["amenity"="kindergarten"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="kindergarten"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          rel["amenity"="kindergarten"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const universityQuery = `[out:json];(
          node["amenity"="college"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          node["amenity"="university"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="college"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="university"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          rel["amenity"="college"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          rel["amenity"="university"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const restaurantsQuery = `[out:json];(
          node["amenity"="restaurant"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          node["amenity"="fast_food"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          node["amenity"="food_court"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="restaurant"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="fast_food"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="food_court"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="restaurant"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="fast_food"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="food_court"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const hospitalsQuery = `[out:json];(
          node["amenity"="hospital"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          node["amenity"="clinic"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="hospital"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="clinic"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="hospital"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="clinic"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const parksQuery = `[out:json];(
          node["leisure"="park"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["leisure"="park"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["leisure"="park"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const busesQuery = `[out:json];(
          node["highway"="bus_stop"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["highway"="bus_stop"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["highway"="bus_stop"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const libraryQuery = `[out:json];(
          node["amenity"="library"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="library"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="library"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const alcoholQuery = `[out:json];(
          node["shop"="alcohol"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          node["shop"="liquor"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["shop"="alcohol"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["shop"="liquor"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["shop"="alcohol"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["shop"="liquor"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const barsQuery = `[out:json];(
          node["amenity"="bar"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          node["amenity"="nightclub"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="bar"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="nightclub"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="bar"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="nightclub"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const gasStationsQuery = `[out:json];(
          node["amenity"="fuel"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="fuel"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="fuel"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        const publicBuildingQuery = `[out:json];(
          node["amenity"="public_building"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          way["amenity"="public_building"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          relation["amenity"="public_building"](around:${neighborhoodFound.maxDistance},${neighborhoodFound.center.latitude},${neighborhoodFound.center.longitude});
          ); out geom;`;

        // console.log(restaurantsQuery, hospitalsQuery, placeOfWorshipsQuery, schoolsQuery, parksQuery); 

        const restaurantsResponse = await axios.post('https://overpass-api.de/api/interpreter', restaurantsQuery);
        const hospitalsResponse = await axios.post('https://overpass-api.de/api/interpreter', hospitalsQuery);
        const placeOfWorshipsResponse = await axios.post('https://overpass-api.de/api/interpreter', placeOfWorshipsQuery);
        const socialFacilityResponse = await axios.post('https://overpass-api.de/api/interpreter', socialFacilityQuery);
        const schoolsResponse = await axios.post('https://overpass-api.de/api/interpreter', schoolsQuery);
        const daycareResponse = await axios.post('https://overpass-api.de/api/interpreter', daycareQuery);
        const universityResponse = await axios.post('https://overpass-api.de/api/interpreter', universityQuery);
        const parksResponse = await axios.post('https://overpass-api.de/api/interpreter', parksQuery);
        const libraryResponse = await axios.post('https://overpass-api.de/api/interpreter', libraryQuery);
        const busesResponse = await axios.post('https://overpass-api.de/api/interpreter', busesQuery);
        const alcoholResponse = await axios.post('https://overpass-api.de/api/interpreter', alcoholQuery);
        const barsResponse = await axios.post('https://overpass-api.de/api/interpreter', barsQuery);
        const gasStationsResponse = await axios.post('https://overpass-api.de/api/interpreter', gasStationsQuery);
        const publicBuildingResponse = await axios.post('https://overpass-api.de/api/interpreter', publicBuildingQuery);

        // console.log("pr:",parksResponse);
        // console.log("rr:",restaurantsResponse);
        // console.log("hr:",hospitalsResponse);
        // console.log("sr:",schoolsResponse);
        // console.log("wr:",placeOfWorshipsResponse);

        const parks = normalizeData(parksResponse);
        const library = normalizeData(libraryResponse);
        const restaurants = normalizeData(restaurantsResponse);
        const hospitals = normalizeData(hospitalsResponse);
        const schools = normalizeData(schoolsResponse);
        const daycare = normalizeData(daycareResponse);
        const university = normalizeData(universityResponse);
        const placeOfWorships = normalizeData(placeOfWorshipsResponse);
        const socialFacility = normalizeData(socialFacilityResponse);
        const buses = normalizeData(busesResponse);
        const alcohol = normalizeData(alcoholResponse);
        const bars = normalizeData(barsResponse);
        const gasStations = normalizeData(gasStationsResponse);
        const publicBuilding = normalizeData(publicBuildingResponse);


        // console.log(parks)

        const restaurantsInNeighborhoods = filterPlacesByNeighborhood(restaurants, neighborhoodFound.geometry.coordinates[0][0]);
        const hospitalsInNeighborhoods = filterPlacesByNeighborhood(hospitals, neighborhoodFound.geometry.coordinates[0][0]);
        const placeOfWorshipsInNeighborhoods = filterPlacesByNeighborhood(placeOfWorships, neighborhoodFound.geometry.coordinates[0][0]);
        const socialFacilityInNeighborhoods = filterPlacesByNeighborhood(socialFacility, neighborhoodFound.geometry.coordinates[0][0]);
        const schoolsInNeighborhoods = filterPlacesByNeighborhood(schools, neighborhoodFound.geometry.coordinates[0][0]);
        const daycareInNeighborhoods = filterPlacesByNeighborhood(daycare, neighborhoodFound.geometry.coordinates[0][0]);
        const universityInNeighborhoods = filterPlacesByNeighborhood(university, neighborhoodFound.geometry.coordinates[0][0]);
        const parksInNeighborhoods = filterPlacesByNeighborhood(parks, neighborhoodFound.geometry.coordinates[0][0]);
        const libraryInNeighborhoods = filterPlacesByNeighborhood(library, neighborhoodFound.geometry.coordinates[0][0]);
        const busesInNeighborhoods = filterPlacesByNeighborhood(buses, neighborhoodFound.geometry.coordinates[0][0]);
        const alcoholInNeighborhoods = filterPlacesByNeighborhood(alcohol, neighborhoodFound.geometry.coordinates[0][0]);
        const barsInNeighborhoods = filterPlacesByNeighborhood(bars, neighborhoodFound.geometry.coordinates[0][0]);
        const gasStationsInNeighborhoods = filterPlacesByNeighborhood(gasStations, neighborhoodFound.geometry.coordinates[0][0]);
        const publicBuildingInNeighborhoods = filterPlacesByNeighborhood(publicBuilding, neighborhoodFound.geometry.coordinates[0][0]);



        const places = { 
          neighborhood: neighborhoodFound.properties.nbhname, 
          restaurants: restaurantsInNeighborhoods, 
          hospitals: hospitalsInNeighborhoods, 
          placeOfWorships: placeOfWorshipsInNeighborhoods, 
          socialFacility: socialFacilityInNeighborhoods, 
          schools: schoolsInNeighborhoods, 
          daycare: daycareInNeighborhoods, 
          university: universityInNeighborhoods,
          parks: parksInNeighborhoods,
          library: libraryInNeighborhoods,
          buses: busesInNeighborhoods,
          alcohol: alcoholInNeighborhoods,
          bars: barsInNeighborhoods,
          gasStations: gasStationsInNeighborhoods,
          publicBuilding: publicBuildingInNeighborhoods
        }

        setNearbyPlaces(places);
        mapData({...places, showIcons: showIcons, showLayer: showLayer});
      } catch (error) {
        console.error('Error fetching data from Overpass API:', error.message);
      }
    };

    getNearbyPlacesInNeighborhoods();
  }, [lat, lng]);

  return (
    <TableContainer component={Paper}>
      {Object.entries(groupedCategories).map(([groupName, categories]) => (
        <Accordion key={groupName}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>{groupName}</AccordionSummary>
          <AccordionDetails>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Category</TableCell>
                  <TableCell>Total</TableCell>
                  <TableCell>Show Icons</TableCell>
                  <TableCell>Show Layer</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{getCategoryTableRows(categories)}</TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>
      ))}

      <br/><br/><br/>

      {additionalData && (
        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>General Info</TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Neighborhood Name</TableCell>
                <TableCell>{additionalData?.nbhname}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        
          {Object.entries(groupedAdditionalInfo).map(([groupKey, group]) => (
            <Accordion key={groupKey} style={{ marginTop: '10px' }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                {group.displayName}
              </AccordionSummary>
              <AccordionDetails>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Attribute</TableCell>
                      <TableCell>Value</TableCell>
                      {/* <TableCell>Select</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {group.attributes.map((key) => (
                      <TableRow key={key}>
                        <TableCell>{additionalInfoDisplayNames[key] || key}</TableCell>
                        <TableCell>{additionalData?.[key]}</TableCell>
                        {/* <TableCell>
                          <FormControlLabel
                            control={
                              <Radio
                                checked={selectedAttribute.name === key}
                                onChange={() => handleAttributeSelect(key)}
                              />
                            }
                            label=""
                          />
                        </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
          ))}
        </TableContainer>
      )}
    
    </TableContainer>
    // <div>
    //   <table style={{ borderCollapse: 'collapse', width: '100%' }}>
    //     <thead>
    //       <tr style={{ borderBottom: '1px solid black' }}>
    //         <th style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>Category</th>
    //         <th style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>Total</th>
    //         <th style={{ borderBottom: '1px solid black', padding: '8px' }}>Show Icons</th>
    //         <th style={{ borderBottom: '1px solid black', padding: '8px' }}>Show Layer</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       <tr style={{ borderBottom: '1px solid black' }}>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>Restaurants</td>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>{nearbyPlaces.restaurants.length}</td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showIcons.restaurants}
    //             onChange={(e) => handleCheckboxChange('restaurants', e.target.checked)}
    //           />
    //         </td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showLayer.restaurants}
    //             onChange={(e) => handleLayerCheckboxChange('restaurants', e.target.checked)}
    //           />
    //         </td>
    //       </tr>
    //       <tr style={{ borderBottom: '1px solid black' }}>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>Hospitals</td>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>{nearbyPlaces.hospitals.length}</td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showIcons.hospitals}
    //             onChange={(e) => handleCheckboxChange('hospitals', e.target.checked)}
    //           />
    //         </td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showLayer.hospitals}
    //             onChange={(e) => handleLayerCheckboxChange('hospitals', e.target.checked)}
    //           />
    //         </td>
    //       </tr>
    //       <tr style={{ borderBottom: '1px solid black' }}>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>Place of Worships</td>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>{nearbyPlaces.placeOfWorships.length}</td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showIcons.placeOfWorships}
    //             onChange={(e) => handleCheckboxChange('placeOfWorships', e.target.checked)}
    //           />
    //         </td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showLayer.placeOfWorships}
    //             onChange={(e) => handleLayerCheckboxChange('placeOfWorships', e.target.checked)}
    //           />
    //         </td>
    //       </tr>
    //       <tr style={{ borderBottom: '1px solid black' }}>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>Schools</td>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>{nearbyPlaces.schools.length}</td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showIcons.schools}
    //             onChange={(e) => handleCheckboxChange('schools', e.target.checked)}
    //           />
    //         </td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showLayer.schools}
    //             onChange={(e) => handleLayerCheckboxChange('schools', e.target.checked)}
    //           />
    //         </td>
    //       </tr>
    //       <tr style={{ borderBottom: '1px solid black' }}>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>Parks</td>
    //         <td style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px' }}>{nearbyPlaces.parks.length}</td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showIcons.parks}
    //             onChange={(e) => handleCheckboxChange('parks', e.target.checked)}
    //           />
    //         </td>
    //         <td style={{ borderBottom: '1px solid black', padding: '8px' }}>
    //           <input
    //             type="checkbox"
    //             checked={showLayer.parks}
    //             onChange={(e) => handleLayerCheckboxChange('parks', e.target.checked)}
    //           />
    //         </td>
    //       </tr>
    //     </tbody>
    //   </table>
    // </div>
  );
};

export default NearbyPlacesComponent;